const o = "Zgadzam się", e = "Świętować", s = "Ukończony", t = "Nie zgadzam się", c = "Śmieszny", n = "Cześć", a = "Kochać", i = "Wow", z = {
  agree: o,
  celebrate: e,
  completed: s,
  disagree: t,
  funny: c,
  hi: n,
  love: a,
  wow: i
};
export {
  o as agree,
  e as celebrate,
  s as completed,
  z as default,
  t as disagree,
  c as funny,
  n as hi,
  a as love,
  i as wow
};
